import React from 'react';
import { Form } from 'react-bootstrap';
import { Formik, FormikHelpers } from 'formik';
import { useTranslation } from 'react-i18next';

import { PasswordIcon } from 'icons';
import { IResetPayload } from 'thunks/auth';
import { isErrorString } from 'utils/handle-api-response';
import { Prompt } from 'react-router-dom';
import { Button } from '../../Button';
import { Modal } from '../../Modal/Modal';

interface IResetProps {
  show: boolean;
  initialValues: IResetPayload;
  validationSchema: any | (() => any);
  error?: any;
  onClose: () => any;
  onSubmit: (
    values: IResetPayload,
    form: FormikHelpers<IResetPayload>
  ) => void | Promise<any>;
}

export const Reset = ({
  show,
  initialValues,
  validationSchema,
  error = undefined,
  onClose,
  onSubmit,
}: IResetProps) => {
  const { t } = useTranslation();
  return (
    <Modal title={t('reset.title')} show={show} onClose={onClose}>
      {isErrorString(error) && (
        <div className="alert alert-error">{error.errors}</div>
      )}
      <p className="mb-40 text-center">{t('reset.info')}</p>
      <Formik
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        initialValues={initialValues}
      >
        {({ handleSubmit, handleChange, values, errors, touched, dirty }) => {
          return (
            <>
              <Prompt when={dirty} message={t('unsavedChanges.message')} />

              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="password">
                  <Form.Label>{t('password.label')}</Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    placeholder={t('password.placeholder')}
                    value={values.password}
                    onChange={handleChange}
                    isInvalid={touched.password && !!errors.password}
                  />
                  <PasswordIcon />
                </Form.Group>

                <Form.Group className="mb-50" controlId="passwordConfirmation">
                  <Form.Label>{t('passwordConfirmation.label')}</Form.Label>
                  <Form.Control
                    type="password"
                    name="passwordConfirmation"
                    placeholder={t('passwordConfirmation.label')}
                    value={values.passwordConfirmation}
                    onChange={handleChange}
                    isInvalid={
                      touched.passwordConfirmation &&
                      !!errors.passwordConfirmation
                    }
                  />
                  <PasswordIcon />
                  <Form.Control.Feedback type="invalid">
                    {!!errors && errors.passwordConfirmation}
                  </Form.Control.Feedback>
                </Form.Group>

                <Button dimension="lg" full type="submit">
                  {t('reset.button')}
                </Button>
              </Form>
            </>
          );
        }}
      </Formik>
    </Modal>
  );
};

Reset.defaultProps = {
  error: undefined,
};
